import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
    Backdrop,
    Button,
    CircularProgress,
    DialogActions,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Switch,
    TextField,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DeleteOutlineSharp } from "@mui/icons-material";

const CreativeDialog = (props) => {
    const imageInputRef1 = React.useRef();
    const imageInputRef2 = React.useRef();
    const imageInputRef3 = React.useRef();
    const [onFileSelectError, setOnFileSelectError] = useState("");
    const [isBannerFilled, setisBannerFilled] = useState("");

    const {
        displayDialog,
        handleCloseCreativeDialog,
        action,
        selectedCreative,
        handleCreative,
        btnloading,
        onCreativeSubmit,
        setSelectedCreative,
    } = props;

    const clearImageRefs = (item) => {
        if (item === '1') {
            setSelectedCreative({ ...selectedCreative, vchImageURL1: "" });
            imageInputRef1.current.value = "";
        } else if (item === '2') {
            setSelectedCreative({ ...selectedCreative, vchImageURL2: "" });
            imageInputRef2.current.value = "";
        } else if (item === '3') {
            setSelectedCreative({ ...selectedCreative, vchImageURL3: "" });
            imageInputRef3.current.value = "";
        }
        
    };

    const handleClearImage = (item) => {
        if (item === '1') {
            setSelectedCreative({ ...selectedCreative, vchImageURL1: "" });
        } else if (item === '2') {
            setSelectedCreative({ ...selectedCreative, vchImageURL2: "" });
        } else if (item === '3') {
            setSelectedCreative({ ...selectedCreative, vchImageURL3: "" });
        }
    };

    const handleFileChange = (e, item) => {
        if (!e.target.files) return;
        const file = e.target.files[0];
        setOnFileSelectError("");
        let fileSize = file?.size;
        fileSize = fileSize / 1048576;
        if (fileSize > 10) {
            setOnFileSelectError("File size cannot exceed more than 10MB");
        } else {
            const reader = new FileReader();
            reader.onloadend = () => {
                const imageData = reader.result;
                if (item === '1') {
                    setSelectedCreative({ ...selectedCreative, vchImageURL1: imageData });
                } else if (item === '2') {
                    setSelectedCreative({ ...selectedCreative, vchImageURL2: imageData });
                } else if (item === '3') {
                    setSelectedCreative({ ...selectedCreative, vchImageURL3: imageData });
                }
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = () => {
        if (!selectedCreative?.vchCreativeName) {
            setisBannerFilled("Please enter Creative Name");
            return
        } else {
            setisBannerFilled("");
        }
        if (!selectedCreative?.vchImageURL1) {
            setOnFileSelectError("Right Board Banner is Required");
            return
        } else if (onFileSelectError) {
            return
        }
        if (!selectedCreative?.vchImageURL2) {
            setOnFileSelectError("Vertical Flavor Board Banner is Required");
            return
        } else if (onFileSelectError) {
            return
        }
        if (!selectedCreative?.vchImageURL3) {
            setOnFileSelectError("Horizontal Flavor Board Banner is Required");
            return
        } else if (onFileSelectError) {
            return
        }
        if (dayjs(selectedCreative?.dteStartDate).format('YYYY-MM-DD') > dayjs(selectedCreative?.dteEndDate).format('YYYY-MM-DD')) {
            return
        }
        onCreativeSubmit()
    }

    return (
        <div>
            {" "}
            <Dialog
                maxWidth="sm"
                fullWidth="false"
                sx={{ zIndex: 1000 }}
                PaperProps={{
                    style: {
                        minWidth: "37%",
                        maxWidth: "47%",
                        minHeight: props?.IsAdmin ? "60%" : '30%',
                        maxHeight: "94%",
                    },
                }}
                open={displayDialog}
                onClose={handleCloseCreativeDialog}
            >
                <DialogTitle>{action} Creative</DialogTitle>
                <Divider />
                <DialogContent>
                    <Backdrop
                        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={btnloading}
                        onClick={handleCloseCreativeDialog}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={12} sm={12} md={12}>
                            <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                                <TextField
                                    size="small"
                                    label="Name"
                                    id="vchCreativeName"
                                    disabled={!props?.IsAdmin}
                                    name="vchCreativeName"
                                    variant="outlined"
                                    required
                                    error={isBannerFilled && !selectedCreative?.vchCreativeName ? true : ""}
                                    value={selectedCreative?.vchCreativeName}
                                    onChange={(e) => {
                                        handleCreative(e.target.value, "vchCreativeName");
                                    }}
                                />
                                <div style={{ color: "red" }}>
                                    {isBannerFilled && !selectedCreative?.vchCreativeName && (
                                        <FormHelperText style={{ color: "red" }}>{isBannerFilled}</FormHelperText>
                                    )}
                                </div>
                            </FormControl>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl sx={{ m: 1, minWidth: "95%" }}>
                                {action === "Add" && (
                                    <FormControlLabel
                                        sx={{ pl: 2 }}
                                        control={
                                            <Switch
                                                checked={selectedCreative?.bitMandatory}
                                                onChange={(e) =>
                                                    handleCreative(e.target.checked, "bitMandatory")
                                                }
                                                name="bitMandatory"
                                                id="bitMandatory"
                                                label="Mandatory"
                                            />
                                        }
                                        label="Default"
                                    />
                                )}
                                </FormControl>
                            </Grid>
                            {selectedCreative?.bitMandatory != 0 && (
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl sx={{ m: 1, minWidth: "95%" }}>
                                        <FormControlLabel
                                            sx={{ pl: 2 }}
                                            control={
                                                <Switch
                                                    checked={selectedCreative?.bitRequired}
                                                    onChange={(e) =>
                                                        handleCreative(e.target.checked, "bitRequired")
                                                    }
                                                    name="bitRequired"
                                                    id="bitRequired"
                                                    label="bitRequired"
                                                />
                                            }
                                            label="Is Optional"
                                        />
                                    </FormControl>
                                </Grid>
                            )}
                        </Grid> 
                        {selectedCreative?.bitMandatory!=0 && (
                            <Grid item xs={12} sm={12} md={6} style={{ margin: '15px 0px' }}>
                                <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"Start Date"}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    error: false,
                                                },
                                            }}
                                            adapterLocale="en"
                                            format="MM/DD/YYYY"
                                            value={dayjs(selectedCreative?.dteStartDate)}
                                            onChange={(newValue) => handleCreative(newValue, "dteStartDate")}
                                        />
                                    </LocalizationProvider>
                                    {dayjs(selectedCreative?.dteStartDate).format('YYYY-MM-DD') >
                                        dayjs(selectedCreative?.dteEndDate).format('YYYY-MM-DD') && (
                                            <FormHelperText style={{ color: 'red' }}>
                                                {"Start Date should be less than End Date"}
                                            </FormHelperText>
                                        )}
                                </FormControl>
                            </Grid>
                        )}
                        {selectedCreative?.bitMandatory!=0 && (
                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label={"End Date"}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    error: false,
                                                },
                                            }}
                                            adapterLocale="en"
                                            format="MM/DD/YYYY"
                                            value={dayjs(selectedCreative?.dteEndDate)}
                                            onChange={(newValue) => handleCreative(newValue, "dteEndDate")}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        )}

                        {props?.IsAdmin ? <Grid item xs={12} sm={4} md={12}>
                            {selectedCreative?.vchImageURL1 ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 15px' }}>
                                    <div>Right Board:</div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginLeft: '20px',
                                            marginTop: '20px'
                                        }}
                                    >
                                        <div>
                                            <img
                                                width="120px"
                                                height="120px"
                                                src={selectedCreative?.vchImageURL1}
                                                onError={(event) => {
                                                    event.target.src = "../assets/icons/notfound.png";
                                                    event.onerror = null;
                                                }}
                                                alt="The current file"
                                            />
                                        </div>
                                        <div>
                                            <DeleteOutlineSharp
                                                color="error"
                                                onClick={() => handleClearImage('1')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                    <div style={{ display: 'flex', alignItems: 'center', padding: '0px 15px', justifyContent: 'space-between' }}>
                                    <div>Right Board:</div>
                                    <FormControl
                                        sx={{ m: 1, margin: '10px'}}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <label htmlFor="upload-photo1">
                                            <input
                                                style={{ display: "none" }}
                                                id="upload-photo1"
                                                name="upload-photo1"
                                                type="file"
                                                accept="image/*"
                                                onClick={()=>clearImageRefs('1')}
                                                ref={imageInputRef1}
                                                onChange={(e) => handleFileChange(e, '1')}
                                            />
                                            <Button
                                                color="secondary"
                                                style={{ backgroundColor: "#D41042" }}
                                                variant="contained"
                                                component="span"
                                            >
                                                Upload Image <FileUploadIcon />
                                            </Button>
                                        </label>{" "}
                                        {onFileSelectError && (
                                            <FormHelperText style={{ color: 'red' }}>{"Right Board Banner is Required"}</FormHelperText>
                                        )}
                                    </FormControl>
                                </div>

                            )}
                            <p style={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end', fontSize: '13px', marginRight: '30px', marginTop: '5px' }}>Dimensions : Width - 645px Height - 490px</p>
                            <br />
                            {selectedCreative?.vchImageURL2 ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 15px' }}>
                                    <div>Horizontal Flavor Board:</div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginLeft: '20px'
                                        }}
                                    >
                                        <div>
                                            <img
                                                width="120px"
                                                height="120px"
                                                src={selectedCreative?.vchImageURL2}
                                                onError={(event) => {
                                                    event.target.src = "../assets/icons/notfound.png";
                                                    event.onerror = null;
                                                }}
                                                alt="The current file"
                                            />
                                        </div>
                                        <div>
                                            <DeleteOutlineSharp
                                                color="error"
                                                onClick={() => handleClearImage('2')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 15px' }}>
                                    <div>Horizontal Flavor Board:</div>
                                    <FormControl
                                        sx={{ m: 1, margin: '10px' }}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <label htmlFor="upload-photo2">
                                            <input
                                                style={{ display: "none" }}
                                                id="upload-photo2"
                                                name="upload-photo2"
                                                type="file"
                                                accept="image/*"
                                                onClick={() =>clearImageRefs('2')}
                                                ref={imageInputRef2}
                                                    onChange={(e) => handleFileChange(e, '2')}
                                            />
                                            <Button
                                                color="secondary"
                                                style={{ backgroundColor: "#D41042" }}
                                                variant="contained"
                                                component="span"
                                            >
                                                Upload Image <FileUploadIcon />
                                            </Button>
                                        </label>{" "}
                                        {onFileSelectError && (
                                            <FormHelperText style={{ color: 'red' }}>{"Vertical Flavor Board Banner is Required"}</FormHelperText>
                                        )}
                                    </FormControl>
                                </div>
                            )}
                            <p style={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end', fontSize: '13px', marginRight: '30px', marginTop: '5px' }}>Dimensions : Width - 930px Height - 520px</p>
                            <br />
                            {selectedCreative?.vchImageURL3 ? (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 15px' }}>
                                    <div>Vertical Flavor Board:</div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            marginLeft: '20px'
                                        }}
                                    >
                                        <div>
                                            <img
                                                width="120px"
                                                height="120px"
                                                src={selectedCreative?.vchImageURL3}
                                                onError={(event) => {
                                                    event.target.src = "../assets/icons/notfound.png";
                                                    event.onerror = null;
                                                }}
                                                alt="The current file"
                                            />
                                        </div>
                                        <div>
                                            <DeleteOutlineSharp
                                                color="error"
                                                onClick={() => handleClearImage('3')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0px 15px' }}>
                                    <div>Vertical Flavor Board:</div>
                                    <FormControl
                                        sx={{ m: 1, margin: '10px' }}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <label htmlFor="upload-photo3">
                                            <input
                                                style={{ display: "none" }}
                                                id="upload-photo3"
                                                name="upload-photo3"
                                                type="file"
                                                accept="image/*"
                                                onClick={()=>clearImageRefs('3')}
                                                ref={imageInputRef3}
                                                    onChange={(e) => handleFileChange(e, '3')}
                                            />
                                            <Button
                                                color="secondary"
                                                style={{ backgroundColor: "#D41042" }}
                                                variant="contained"
                                                component="span"
                                            >
                                                Upload Image <FileUploadIcon />
                                            </Button>
                                        </label>{" "}
                                        {onFileSelectError && (
                                            <FormHelperText style={{ color: 'red' }}>{"Cretive 3 Banner is Required"}</FormHelperText>
                                        )}
                                    </FormControl>
                                </div>
                            )}
                            <p style={{ display: 'flex', alignItems: 'end', justifyContent: 'flex-end', marginRight: '30px', fontSize: '13px', marginTop: '5px' }}>Dimensions : Width - 1010px Height - 342px</p>
                        </Grid> : null}
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button onClick={handleCloseCreativeDialog} disabled={btnloading}>
                        Close
                    </Button>
                    {action === "Add" && (
                        <Button onClick={handleSubmit} disabled={btnloading}>
                            Add
                        </Button>
                    )}
                    {action === "Update" && (
                        <Button onClick={handleSubmit} disabled={btnloading}>
                            Update
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default CreativeDialog;
